module.exports = __webpack_public_path__ + "static/media/image2.97fa59e9.jpg";